/** @hidden */
export const headers = { 'Content-Type': 'application/json' };

/**@hidden */
export const logPrefix = '[Arc Auth0 Identity SDK]';
